function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import AppEvent from "zengular/src/app-event";

var RespoHandler = /*#__PURE__*/function () {
  function RespoHandler(breakpoints) {
    var _this = this;

    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, RespoHandler);

    this.handler = handler;
    this.breakpoints = breakpoints;
    this.mode = null;
    this.calculate(window.innerWidth);
    window.addEventListener('resize', function () {
      return _this.calculate(window.innerWidth);
    });
  }

  _createClass(RespoHandler, [{
    key: "calculate",
    value: function calculate(width) {
      var mode = null;

      for (var view in this.breakpoints) {
        if (this.breakpoints.hasOwnProperty(view)) {
          var min = this.breakpoints[view].min;
          var max = this.breakpoints[view].max;
          if (width >= min && width < max) mode = view;
        }
      }

      if (mode !== this.mode) {
        this.mode = mode;
        AppEvent.broadcast('respo-change', {
          view: mode
        });
      }

      if (typeof this.handler === "function") this.handler(mode);
    }
  }]);

  return RespoHandler;
}();

export { RespoHandler as default };